import { Link } from "react-router-dom";
import { CardProductContainer } from "./style";
import { useDispatch, useSelector } from "react-redux";
import { getStorageCart } from "../../store/cart/addCart/cartSlice";

export function CardProduct(props) {
  const data = useSelector((state) => state.cartSlice.data);

  const dispatch = useDispatch();

  function addToCart() {
    if (props.id === 1) {
      dispatch(getStorageCart(props, [...data]));
    } else {
      return console.error("Produto não encontrado");
    }
  }

  return (
    <CardProductContainer>
      <img src={props.img} alt="" />
      <p className="cardTitle">{props.name}</p>
      <p className="price">
        {props.price.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })}
      </p>
      <button className="addCart" onClick={addToCart}>
        Adicionar ao carrinho
      </button>
      <Link className="productDetails">Detalhes do produto</Link>
    </CardProductContainer>
  );
}
